import { useMemo } from 'react'
import useSiteState from './useSiteState'

const useBoundFilterQueryElementUuid = (
  elementUuid: string,
  isolateFilterQuery?: boolean
) => {
  const [boundFilterQueryElements] = useSiteState<string[]>(
    'bound-filter-query-elements'
  )

  return useMemo(() => {
    if (isolateFilterQuery) {
      return elementUuid
    }

    return boundFilterQueryElements?.includes(elementUuid)
      ? elementUuid
      : undefined
  }, [elementUuid, boundFilterQueryElements, isolateFilterQuery])
}

export default useBoundFilterQueryElementUuid
